import { render } from "./ContentPin.vue?vue&type=template&id=2af40c6e"
import script from "./ContentPin.vue?vue&type=script&lang=js"
export * from "./ContentPin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__